<template>
  <div class="room-bulletingboard-message-reaction">
    <a @click="toggleReaction">
      <div v-if="is_reacted" class="reacted">
        <div class="reaction-box">
          <img src="../../assets/img/thumb_up_white.svg" alt />
          <span class="reaction-count">{{ reaction_count }}</span>
        </div>
      </div>
      <div v-else class="not_reacted">
        <div class="reaction-box">
          <img src="../../assets/img/thumb_up_pink.svg" alt />
          <span class="reaction-count">{{ reaction_count }}</span>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import M from "materialize-css";
import { db } from "./../../App.vue";

export default {
  name: "RoomMessageReaction",
  props: {
    reaction: Object,
    message_id: String,
    is_login: Boolean,
    current_user_id: String
  },
  computed: {
    reaction_count: function() {
      if (this.reaction === null) {
        return 0;
      }
      return Object.keys(this.reaction).length;
    },
    is_reacted: function() {
      if (this.reaction === null) {
        return false;
      }
      return this.reaction.hasOwnProperty(this.current_user_id);
    },
    roomId: function() {
      return this.$route.params.room_id;
    }
  },
  methods: {
    toggleReaction: function() {
      if (!this.is_login) {
        M.toast({
          html: "ログインが必要です",
          displayLength: 1000
        });
        return;
      }
      if (this.is_reacted) {
        db.ref(
          `reactions/${this.roomId}/${this.message_id}:${this.current_user_id}`
        ).remove();
      } else {
        db.ref(
          `reactions/${this.roomId}/${this.message_id}:${this.current_user_id}`
        ).set(true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.room-bulletingboard-message-reaction {
  margin: 12px 15px 10.5px 0px;
  a {
    cursor: pointer;
    user-select: none;
    color: inherit;
    $height: 30.5px;

    .reacted {
      border-radius: 31px;
      background-color: #f93099;
      color: #ffffff;
    }
    .not_reacted {
      border-radius: 31px;
      border: solid 1px #cccccc;
      background-color: #ffffff;
      color: #333333;
    }
    .reaction-box {
      height: $height;
      display: flex;
      min-width: 55px;

      img {
        padding: 9px 0px 8.5px 5px;
        margin: -2px 0px;
      }

      .reaction-count {
        margin: 10px 9.5px 10px 0px;
        font-family: HiraKakuPro-W6;
        font-size: 12px;
        line-height: 1.085;
      }
    }
  }
}
</style>
